import { IUnitsConversionSet, IUnitsConverter, UnitsConversionModes, UnitsConversionSets } from "./IUnitsConverter";

export class DefaultUnitsConverter implements IUnitsConverter {
    public constructor(private mode: UnitsConversionModes = UnitsConversionModes.DEFAULT) {
        console.info('Selected UnitsConversionMode: ', this.mode);
    }

    public getConversionSet(sourceUnits: string, parameterGroupOrParamId?: string): IUnitsConversionSet | null {
        if (this.mode !== UnitsConversionModes.DEFAULT) {
            if (parameterGroupOrParamId && typeof (parameterGroupOrParamId) == 'string') {
                return UnitsConversionSets.find(sourceUnits, this.mode, parameterGroupOrParamId.indexOf('Visibility') !== -1);
            } else { //:  "If parameterGroup is not set then assume the conversion is m -> ft."
                return UnitsConversionSets.find(sourceUnits, this.mode, false);
            }
        }

        return null;
    }

    public getConvertedUnits(sourceUnits: string, parameterGroupOrParamId?: string): string {
        if (this.mode == UnitsConversionModes.DEFAULT) {
            return sourceUnits;
        } else {
            let _set = this.getConversionSet(sourceUnits, parameterGroupOrParamId);
            if (!_set) {
                return sourceUnits;
            } else {
                return _set.convertedUnits;
            }
        }
    }

    public convert(value: number, sourceUnits: string, parameterGroupOrParamId?: string): number {
        if (this.mode == UnitsConversionModes.DEFAULT) {
            return value;
        } else {
            let _set = this.getConversionSet(sourceUnits, parameterGroupOrParamId);
            if (!_set) {
                return value;
            } else {
                //console.info('UnitConvert', parameterGroupOrParamId, value, sourceUnits, '*', _set.factor, '=', value * _set.factor, _set.convertedUnits);
                //return value * _set.factor;
                return _set.convertValue(value);
            }
        }
    }
}